import React from "react";
import "./SalesReportItem.scss";

interface Props {
  title?: string;
  number?: number;
  onItemClick?: () => void;
}

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

const SalesReportItem: React.FC<Props> = (props) => {
  const { title, number, onItemClick } = props;

  return (
    <div className="sales-report-item" onClick={onItemClick}>
      <div className="title">{title}</div>
      <div className="number">{numberFormat(number)}</div>
    </div>
  );
};

export default SalesReportItem;
